import { render, staticRenderFns } from "./Robohead.vue?vue&type=template&id=116e9f87&scoped=true&"
import script from "./Robohead.vue?vue&type=script&lang=js&"
export * from "./Robohead.vue?vue&type=script&lang=js&"
import style0 from "./Robohead.vue?vue&type=style&index=0&id=116e9f87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e9f87",
  null
  
)

export default component.exports